import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

export const Container = styled(Box)`
  padding: 32px 46px;
  display: flex;
  width: 75%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: ${({ theme }) => theme.spacing(1)};
  margin: ${({ theme }) => theme.spacing(2)} auto;
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14),
    0px 1px 3px rgba(0, 0, 0, 0.12);

  @media (min-width: 800px) {
    width: 696px;
  }
`;

export const StepTitle = styled(Typography)`
  font-weight: 600 !important;
  color: ${({ theme }) => theme.palette.grey[700]};
  text-transform: uppercase;
`;

export const Title = styled(Typography)`
  font-weight: 600 !important;
  color: ${({ theme }) => theme.palette.primary.main};
  text-transform: uppercase;
`;

export const Description = styled(Typography)`
  font-size: 14px !important;
  color: ${({ theme }) => theme.palette.grey[700]};
  text-align: center;
  margin: ${({ theme }) => theme.spacing(1, 0, 2, 1)} !important;
`;
